import { Box, Button, Modal } from "@modernatx-internal/component-library";
import React from "react";

import { ConfirmationModalContent, ContentComponentProps } from "../types";

/** A dismissible confirmation dialog opened by a button; it records no attestation. */
export const ConfirmationModal: React.FC<ContentComponentProps<ConfirmationModalContent>> = ({
  title,
  trigger,
  buttons,
  children
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      {React.isValidElement<{ onClick?: () => void }>(trigger) &&
        React.cloneElement(trigger, { onClick: () => setIsOpen(true) })}
      <Modal title={title} size="lg" isOpen={isOpen} onDismiss={() => setIsOpen(false)}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {children}
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "start", gap: 3 }}>
            {buttons.map(({ label, href, variant, closeOnClick }, i) => (
              <Button
                key={i}
                href={href}
                variant={variant}
                onClick={closeOnClick ? () => setIsOpen(false) : undefined}
              >
                {label}
              </Button>
            ))}
          </Box>
        </Box>
      </Modal>
    </>
  );
};
